import { useQuery } from '@tanstack/react-query';
import { get, isArray, map } from 'lodash';
import { CCApiResponse } from 'src/interfaces';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';
import { mapProductsWithVariation } from './helper';

export const useGetProductsByCategory = (
  productCategoryId: string | number[],
  enabled = true,
) =>
  useQuery({
    queryKey: queryKeys.products.details(
      isArray(productCategoryId)
        ? `productCategoryId=${productCategoryId.join('|')}`
        : `productCategoryId=${productCategoryId}`,
    ),
    queryFn: () => fetchProductsByCategories(productCategoryId),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

const fetchProductsByCategories = async (
  productCategoryId: string | number[],
) => {
  let url;
  if (Array.isArray(productCategoryId) && productCategoryId.length > 0) {
    url = `/products?product_category_id=${productCategoryId.join(
      '|',
    )}&pageSize=0`;
  } else if (
    Array.isArray(productCategoryId) &&
    productCategoryId.length === 0
  ) {
    url = `/products?pageSize=0`;
  } else {
    url = `/products?product_category_id=${productCategoryId}&pageSize=0`;
  }

  const response = await requestCCApi({ url });
  const productCodes = map(response.data, 'product_code');

  if (productCodes) {
    const productsurl = `/productVariations?include=products,productVariationSizes,productVariationFlavors&pageSize=0&group_product_code.list=${productCodes.join(
      '|',
    )}`;

    const responseProducts: CCApiResponse = await requestCCApi({
      url: productsurl,
    });

    const productCategoryUrl = `/productCategories?pageSize=0`;
    const responseCategories: CCApiResponse = await requestCCApi({
      url: productCategoryUrl,
    });

    return mapProductsWithVariation(
      responseProducts,
      get(responseCategories, 'data', []),
    );
  }

  return [];
};
